import {
  AgendaGenerationResult,
  AgendaItem,
  AgendaItemUpdateRequest,
  AgendaResponse
} from "../entities/agenda/Agenda";
import RequestService from "./RequestService";

export * from "../entities/agenda/Agenda";

/** Generation takes 30–70 s on the backend. */
export const AGENDA_GENERATE_TIMEOUT_MS = 120000;

class AgendaService {
  public static get(): Promise<AgendaResponse | Error> {
    return RequestService.get(
      "/agenda",
      {},
      true,
      RequestService.getBaseUrlAssistance()
    );
  }

  /** force=true resets status and assignment of every item; confirm in the UI first. */
  public static generate(
    force = false
  ): Promise<AgendaGenerationResult | Error> {
    return RequestService.post(
      `/agenda/generate?force=${force}`,
      {},
      true,
      RequestService.getBaseUrlAssistance(),
      AGENDA_GENERATE_TIMEOUT_MS
    );
  }

  public static updateItem(
    itemId: number,
    request: AgendaItemUpdateRequest
  ): Promise<AgendaItem | Error> {
    return RequestService.patch(
      `/agenda/items/${itemId}`,
      request,
      true,
      RequestService.getBaseUrlAssistance()
    );
  }

  public static deleteItem(itemId: number): Promise<unknown | Error> {
    return RequestService.delete(
      `/agenda/items/${itemId}`,
      {},
      true,
      RequestService.getBaseUrlAssistance()
    );
  }
}

export default AgendaService;
